module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/mailing-list/component/home-main-modal-drag/home-main-modal-drag.component.sass
// module id = ./src/app/modules/mailing-list/component/home-main-modal-drag/home-main-modal-drag.component.sass
// module chunks = main